export const environment = {
  production: false,
  ENV: 'TST',
  ENV_DESC: '測試環境',
  VER: '21.12.07.01',
  API: 'https://tst-toolbox-safety-meeting-service.cirsolar.cloud/api',
  APP_HOST: 'https://tst-toolbox-safety-meeting-app.cirsolar.cloud/',
};
